import {nowISOString, waitAndReturn} from 'app/demo/utils';

import {UserJobSerializedType} from 'sweet-types';

const fakeUUID = 'f1b66884-c919-467a-9ef1-f16c54c94ec4';

let job: UserJobSerializedType = {
  id: fakeUUID,
  url: `/api/v1/jobs/${fakeUUID}/`,
  description: 'document_diagram',
  started_at: nowISOString(),
  finished_at: null,
  viewed_at: null,
  status: 'processing',
  result: {},
};

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/ban-types */
export const postAsyncJobFetcher = <O>(
  url: string,
  obj: O
): Promise<{job: UserJobSerializedType}> => waitAndReturn({job});

export const userJobDetailsFetcher = (
  url: string
): Promise<UserJobSerializedType> =>
  waitAndReturn(() => {
    job = {
      ...job,
      finished_at: nowISOString(),
      status: 'completed',
      result: {
        url: '/site_media/static/images/demo-procedure-generated-diagram.png',
        type: 'download',
      },
    };
    return job;
  });

export const markUserJobAsViewedFetcher = (
  url: string,
  payload: {}
): Promise<UserJobSerializedType> =>
  waitAndReturn(() => {
    job = {...job, ...payload};
    return job;
  });

/* eslint-enable */
